import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import getImagePath from '../../../CommonUtils/getImagePath';
import { ComponentProps } from '../../CustomFormsWorkflow.meta';
import { selectComponentProps } from '../../../ConsumerArea/ConsumerAreaSelector';

export const ReviewPage = () => {
  const componentProps: ComponentProps = useSelector(selectComponentProps);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" style={{ gap: 16 }}>
      <Text fontSize="h4" fontWeight={600}>
        {componentProps.WorkflowType === 'FpAgreementWorkflow'
          ? 'Success!'
          : 'Information Submitted'}
      </Text>

      <img
        src={getImagePath('nao-agreement-workflow/green-checkmark-illustration.svg')}
        alt="green-checkmark-illustration"
        width={200}
      />

      <Text fontWeight={500} width={586} textAlign="center">
        {componentProps.WorkflowType === 'NaoAgreementWorkflow' && (
          <>
            Thank you for reviewing and submitting your information. Your new account package has
            been sent off for processing.
          </>
        )}

        {componentProps.WorkflowType === 'FpAgreementWorkflow' && (
          <>
            Thank you for reviewing and completing your Planning Agreement. Your data has been sent
            for processing.
          </>
        )}
      </Text>
    </Box>
  );
};
